import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MailOutlined } from "@ant-design/icons";
import { hideEmailVerifyModal, verifyEmailChange } from "../../slice";
import { selectEmailVerification } from "../../selector";
import {
  VerifyCancelButton,
  VerifyModal,
  VerifyModalFooter,
  VerifyModalHint,
  VerifyOtpInput,
  VerifySubmitButton,
} from "../../style";

export default function VerifyEmailModal() {
  const dispatch = useDispatch();
  const { visible, pendingEmail, verifying } = useSelector(
    selectEmailVerification,
  );
  const [otp, setOtp] = useState("");

  function handleClose() {
    setOtp("");
    dispatch(hideEmailVerifyModal());
  }

  function handleSubmit() {
    if (otp.length < 6) return;
    dispatch(verifyEmailChange({ otp }));
  }

  return (
    <VerifyModal
      open={visible}
      title="Verify Email Change"
      onCancel={handleClose}
      footer={null}
      destroyOnClose
      maskClosable={false}
    >
      <VerifyModalHint>
        A verification code has been sent to <strong>{pendingEmail}</strong>.
        Enter the 6-digit code below to confirm your new email address.
      </VerifyModalHint>

      <VerifyOtpInput
        length={6}
        value={otp}
        onChange={setOtp}
        disabled={verifying}
      />

      <VerifyModalFooter justify="flex-end" gap={10}>
        <VerifyCancelButton onClick={handleClose} disabled={verifying}>
          Cancel
        </VerifyCancelButton>
        <VerifySubmitButton
          icon={<MailOutlined />}
          loading={verifying}
          disabled={otp.length < 6}
          onClick={handleSubmit}
        >
          Verify Email
        </VerifySubmitButton>
      </VerifyModalFooter>
    </VerifyModal>
  );
}
